import type { FC, ReactNode } from 'react';
import { useCallback } from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';

interface LinkButtonProps {
  to: string;
  title: string;
  startIcon?: ReactNode;
  disabled?: boolean;
}

const LinkButton: FC<LinkButtonProps> = ({ disabled, to, title, startIcon }) => {
  const navigate = useNavigate();

  const handleToggleAddFlow = useCallback(() => {
    navigate(to, {});
  }, [navigate, to]);

  return (<Button disabled={disabled} startIcon={startIcon} variant="text" size={'small'}
                  onClick={handleToggleAddFlow}>{title}</Button>);
};

export default LinkButton;

